"use strict";

var _ = require("underscore");
var cx = require("classnames");
var EmptyList = require("app/shared/components/List/empty-list");
var ConfigListItem = require("app/shared/components/ConfigList/config-list-item");
var RemoveTeamPrompt = require("app/shared/components/TeamSelector/remove-team-prompt");
var EditTeamPrompt = require("app/shared/components/TeamSelector/edit-team-prompt");
var AddTeamButton = require("app/screens/Team/shared/components/add-team-button");
var PureRenderMixin = React.addons.PureRenderMixin;

var TeamList = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    teams: React.PropTypes.array,
    users: React.PropTypes.array,
    onClosePromptConfirmButtonGroup: React.PropTypes.func,
    changingPrivacy: React.PropTypes.bool
  },
  getListContent: function() {
    if (this.props.teams) {
      if (this.props.teams.length > 0) {
        return this.getTeamList();
      } else {
        return <NoTeamRegistered />;
      }
    }
  },
  getTeamList: function() {
    var teamsList = _.map(this.props.teams, function(team, index, list) {
      var isLastTeam = (index + 1) == list.length;
      var separatorClass = cx({ "b-n": isLastTeam });
      return (
        <TeamListItem 
          key={team.id.toString()} 
          team={team}
          users={this.props.users} 
          className={separatorClass}
          onClosePromptConfirmButtonGroup={this.props.onClosePromptConfirmButtonGroup}
          changingPrivacy={this.props.changingPrivacy}
        />
      );
    }.bind(this));

    return <ul>{teamsList}</ul>;
  },
  render: function() {
    return (
      <div className="w-100 h-100pct m-a">
        {this.getListContent()}
      </div>
    );
  }
});

var NoTeamRegistered = React.createClass({
  mixins: [ReactIntl.IntlMixin, PureRenderMixin],
  getEmptyListMessage: function() {
    return {
      title: this.getIntlMessage("team.no_team_registered.title"),
      subtitle: this.getIntlMessage("team.no_team_registered.subtitle")
    };
  },
  render: function() {
    var emptyListMessages = this.getEmptyListMessage();
    return (
      <EmptyList title={emptyListMessages.title} subtitle={emptyListMessages.subtitle}>
        <AddTeamButton />
      </EmptyList>
    );
  }
});

const TeamListItem = (props) => (
  <ConfigListItem 
    title={props.team.name} 
    syncStatus={props.team.synched}
    className={props.className}
    editPrompt={
      <EditTeamPrompt 
        team={props.team} 
        users={props.users}
        onConfirmSuccess={props.onClosePromptConfirmButtonGroup}
      />
    }
    deletePrompt={
      <RemoveTeamPrompt 
        team={props.team}
        onConfirmSuccess={props.onClosePromptConfirmButtonGroup}
      />
    }
    disabled={props.changingPrivacy}
    >
    <TeamListItemUsers userTeams={props.team.user_teams} />
  </ConfigListItem>
);

const TeamListItemUsers = (props) => {
  var leaders = _.where(props.userTeams, { leader: 1 });
  var members = _.where(props.userTeams, { leader: 0 });
  var isCommaSeparated = !(_.isEmpty(leaders) || _.isEmpty(members));

  return (
    <span>
      <TeamListItemLeaders userTeams={leaders}/>
        {isCommaSeparated ? ", " : ""}
      <TeamListItemMembers userTeams={members}/>
    </span>
  );
};

const TeamListItemLeaders = (props) => (
  <b className="fs-16">
    <UserListing userTeams={props.userTeams} leader={true} />
  </b>
);

const TeamListItemMembers = (props) => (
  <span className="c-666 fs-15">
    <UserListing userTeams={props.userTeams} leader={false} />
  </span>
);

const UserListing = (props) => {
  var usersNameArray = _.map(props.userTeams, function(userTeam) {
    const active = userTeam.user.active === false ? " (inativo)" : ""; // evita erros em casos de cache (mais no deploy inicial)
    return userTeam.user.name + active;
  });
  var usersName = usersNameArray.join(", ");

  return <span>{usersName}</span>;
};

module.exports = TeamList;



// WEBPACK FOOTER //
// ./app/screens/Team/components/TeamConfig/team-list.jsx